import React from 'react';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
import Tooltip from 'components/core/Tooltip';
// Models
import mDeviceLog from 'models/deviceLog';
// Custom
import { listRowSpecsShape, deviceLogDataShape } from 'constants/PropTypesShapes';
import { InfoIconButton } from 'components/buttons/IconButtons';
import AppIcon from 'components/icons/AppIcon';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';

const LogOrigin = ({ deviceLog }) => {
  const { labelId, icon } = mDeviceLog.origin(deviceLog);
  return (
    <div className="d-flex align-items-center">
      <Tooltip content={<LocalizedMessage id={labelId} />}>
        <AppIcon defaultColor id={icon} />
      </Tooltip>
    </div>
  );
};

LogOrigin.propTypes = {
  deviceLog: deviceLogDataShape.isRequired,
};

const LogLevel = ({ deviceLog }) => {
  const { labelId, icon, color } = mDeviceLog.level(deviceLog);
  return (
    <div className="d-flex align-items-center">
      <Tooltip content={<LocalizedMessage id={labelId} />}>
        <AppIcon color={color} id={icon} />
      </Tooltip>
    </div>
  );
};

LogLevel.propTypes = {
  deviceLog: deviceLogDataShape.isRequired,
};

const LogTag = ({ deviceLog }) => {
  const { labelId, icon } = mDeviceLog.tag(deviceLog);
  return (
    <div className="d-flex align-items-center">
      <Tooltip content={<LocalizedMessage id={labelId} />}>
        <AppIcon defaultColor id={icon} />
      </Tooltip>
    </div>
  );
};

LogTag.propTypes = {
  deviceLog: deviceLogDataShape.isRequired,
};

const LogType = ({ deviceLog }) => {
  const deviceLogType = mDeviceLog.type(deviceLog);
  return (
    <TruncatedTooltipText>
      {deviceLogType
        ? <LocalizedMessage id={deviceLogType.labelId} />
        : <em><LocalizedMessage id="info.unknown" values={{ gender: 'male' }} /></em>}
    </TruncatedTooltipText>
  );
};

LogType.propTypes = {
  deviceLog: deviceLogDataShape.isRequired,
};

const LogRow = React.forwardRef(({
  deviceLog, rowSpecs, onDisplayLogInfo,
}, ref) => {
  // Handlers
  const handleDisplayLogInfo = () => {
    onDisplayLogInfo(deviceLog);
  };

  return (
    <TableRow
      ref={ref}
      element={deviceLog}
      rowSpecs={rowSpecs}
      actions={[
        <InfoIconButton key="bInfo" onClick={handleDisplayLogInfo} tooltipId="tooltip.logDetails" />,
      ]}
    >
      <TableCell className={classnames({ 'table-first-details': rowSpecs.withDetails })}>
        <TruncatedTooltipText>
          <LocalizedStandardDate value={deviceLog.date} />
        </TruncatedTooltipText>
      </TableCell>
      <TableCell>
        <LogType deviceLog={deviceLog} />
      </TableCell>
      <TableCell className="hidden-sm-down table-content-1 table-content-center" noPadding>
        <LogTag deviceLog={deviceLog} />
      </TableCell>
      <TableCell className="hidden-sm-down table-content-1 table-content-center" noPadding>
        <LogLevel deviceLog={deviceLog} />
      </TableCell>
      <TableCell className="hidden-md-down table-content-1 table-content-center" noPadding>
        <LogOrigin deviceLog={deviceLog} />
      </TableCell>
      <TableCell className="hidden-md-down">
        <TruncatedTooltipText>{deviceLog.desc}</TruncatedTooltipText>
      </TableCell>
    </TableRow>
  );
});

LogRow.displayName = 'LogRow';

LogRow.propTypes = {
  deviceLog: deviceLogDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  onDisplayLogInfo: PropTypes.func.isRequired,
};

module.exports = LogRow;



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/logs/LogRow.js